/* ============================================================
   KACHING CART - personalizaciones Sentia
   Vive en el tema: assets/sn-kaching-cart.js
   1) Prueba social en el header, pegada al logo -> .sn-social
   2) Cierre propio (el <button> de Kaching lo pinta iOS) -> .sn-close
   3) Aviso de envio con fecha resuelta en el pie -> .sn-ship
   ============================================================ */
(function () {
  'use strict';

  /* ---------- config ---------- */
  var TZ = 'America/Mexico_City'; /* zona del almacen, NO la del cliente */
  var CUTOFF_HOUR = 14;           /* despues de las 14:00 pasa al dia habil siguiente */
  var ESTRELLAS = '★★★★★';
  var NOTA = '4.8';
  var GENTE = '1,200+ clientes';    /* mismos numeros que publica la PDP */

  /* ---------- estilos ---------- */
  var CSS = [
    /* la fila del temporizador ya no se usa */
    '.kaching-cart__module:has(>.kaching-cart__announcement-bar){display:none!important}',
    '.kaching-cart__announcement-bar{display:none!important}',
    /* header: logo + prueba social centrados, cierre propio a la derecha */
    '.kaching-cart__header{position:relative!important;justify-content:center!important;align-items:center!important;gap:9px!important;padding:7px 50px!important}',
    '.kaching-cart__header-image{width:auto!important;max-width:104px!important;flex:0 0 auto!important}',
    '.kaching-cart .kaching-cart__header .kaching-cart__close{display:none!important}',
    '.sn-close{position:absolute!important;right:4px;top:50%;transform:translateY(-50%);width:40px;height:40px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:rgb(var(--m));background:none;border:0;-webkit-tap-highlight-color:transparent}',
    /* chip de resenas */
    '.sn-social{display:inline-flex!important;align-items:center;gap:5px;flex:0 0 auto;font-size:11.5px;font-weight:600;letter-spacing:.012em;line-height:1;color:rgb(var(--m));white-space:nowrap}',
    '.sn-social__stars{color:rgb(245,166,35);font-size:12px;letter-spacing:.5px}',
    '.sn-social__nota{font-weight:700;color:rgb(var(--i))}',
    '@media (max-width:360px){.sn-social__gente{display:none!important}}',
    /* pie: dia de despacho como badge + camion en movimiento */
    '.kaching-cart .kaching-cart__footer .sn-ship b{background:rgb(226,243,234)!important;color:rgb(11,106,66)!important;padding:2px 7px!important;border-radius:6px!important;font-weight:700!important}',
    '@keyframes sn-drive{0%,100%{transform:translateX(0)}45%{transform:translateX(3px)}}',
    '.kaching-cart .kaching-cart__footer .sn-ship svg{animation:sn-drive 1.9s ease-in-out infinite!important}',
    '@media (prefers-reduced-motion:reduce){.kaching-cart .kaching-cart__footer .sn-ship svg{animation:none!important}}'
  ].join('\n');

  function ponerEstilos() {
    if (document.getElementById('sn-css')) return;
    var st = document.createElement('style');
    st.id = 'sn-css';
    st.setAttribute('data-sn-tema', '1');
    st.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(st);
  }

  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var TRUCK = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v13H1z"></path><path d="M14 8h4l3 3v5h-7V8z"></path><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="17.5" cy="18.5" r="2.5"></circle></svg>';
  var EQUIS = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"></path></svg>';

  /* ---------- 1. prueba social ---------- */
  function ponerSocial() {
    var hdr = document.querySelector('.kaching-cart__header');
    if (!hdr || hdr.querySelector('.sn-social')) return;
    var el = document.createElement('span');
    el.className = 'sn-social';
    el.innerHTML =
      '<span class="sn-social__stars">' + ESTRELLAS + '</span>' +
      '<span class="sn-social__nota">' + NOTA + '</span>' +
      '<span class="sn-social__gente">· ' + GENTE + '</span>';
    var logo = hdr.querySelector('.kaching-cart__header-image');
    if (logo && logo.parentNode === hdr) hdr.insertBefore(el, logo.nextSibling);
    else hdr.insertBefore(el, hdr.firstChild);
  }

  /* ---------- 2. cierre propio ---------- */
  function ponerCierre() {
    var hdr = document.querySelector('.kaching-cart__header');
    if (!hdr || hdr.querySelector('.sn-close')) return;
    var el = document.createElement('span');
    el.className = 'sn-close';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', 'Cerrar');
    el.innerHTML = EQUIS;
    function cerrar(e) {
      e.preventDefault();
      try { window.kachingCartApi.closeCart(); }
      catch (err) {
        var orig = document.querySelector('.kaching-cart__close');
        if (orig) orig.click();
      }
    }
    el.addEventListener('click', cerrar);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') cerrar(e);
    });
    hdr.appendChild(el);
  }

  /* ---------- 3. fecha de despacho ---------- */
  function partesEnZona() {
    var f = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false
    }).formatToParts(new Date());
    var o = {}, i;
    for (i = 0; i < f.length; i++) o[f[i].type] = parseInt(f[i].value, 10);
    return o;
  }

  function textoDespacho() {
    var p = partesEnZona();
    /* fecha "virtual" en UTC: permite sumar dias sin que el huso la corra */
    var d = new Date(Date.UTC(p.year, p.month - 1, p.day));
    var dow = d.getUTCDay();
    var esHabil = dow >= 1 && dow <= 5;
    var saleHoy = esHabil && p.hour < CUTOFF_HOUR;
    var saltados = 0;

    if (!saleHoy) {
      do {
        d.setUTCDate(d.getUTCDate() + 1);
        saltados++;
        dow = d.getUTCDay();
      } while (dow === 0 || dow === 6);
    }

    if (saleHoy) return 'Tu pedido sale <b>hoy</b>';
    if (saltados === 1) return 'Tu pedido sale <b>mañana</b>';
    return 'Tu pedido sale el <b>' + DIAS[d.getUTCDay()] + ' ' + d.getUTCDate() + '</b>';
  }

  var cacheTexto = '', cacheHasta = 0;
  function textoCacheado() {
    var ahora = +new Date();
    if (ahora > cacheHasta) { cacheTexto = textoDespacho(); cacheHasta = ahora + 60000; }
    return cacheTexto;
  }

  function ponerAviso() {
    var pie = document.querySelector('.kaching-cart__footer');
    if (!pie) return;
    var nodo = pie.querySelector('.sn-ship');
    var html = TRUCK + '<span>' + textoCacheado() + '</span>';
    if (!nodo) {
      nodo = document.createElement('div');
      nodo.className = 'sn-ship';
      nodo.setAttribute('data-sn-tema', '1');
      nodo.innerHTML = html;
      pie.insertBefore(nodo, pie.firstChild);
    } else if (nodo.innerHTML !== html) {
      nodo.innerHTML = html;
    }
  }

  /* ---------- variante B del A/B del carrito: tiene su propio JS/CSS ----------
     B usa el mismo id #sn-css y la clase .sn-ship: se borra solo lo marcado data-sn-tema,
     para no pisar lo de B ni dejar que el tema le bloquee su CSS. */
  var VARIANTE_B = 'kungL-dhB9rm';

  function esVarianteB() {
    try { return localStorage.getItem('kaching_cart_ab_variant') === VARIANTE_B; }
    catch (e) { return false; }
  }

  function limpiar() {
    var sel = ['#sn-css[data-sn-tema]', '.sn-social', '.sn-close', '.sn-ship[data-sn-tema]'], i, n;
    for (i = 0; i < sel.length; i++) {
      n = document.querySelector(sel[i]);
      if (n && n.parentNode) n.parentNode.removeChild(n);
    }
  }

  /* ---------- loop ---------- */
  function tick() {
    if (esVarianteB()) { limpiar(); return; }
    try { ponerEstilos(); } catch (e) { }
    try { ponerSocial(); } catch (e) { }
    try { ponerCierre(); } catch (e) { }
    try { ponerAviso(); } catch (e) { }
  }

  tick();
  setInterval(tick, 400); /* React repinta el cajon: esto reinserta si lo borra */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
})();
